// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryPostingProfile.yaml
// Generated: 2026-01-22T15:19:14.202Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInventoryPostingProfile, UpdateInventoryPostingProfile, InventoryPostingProfile } from '@/types/inventory/InventoryPostingProfile';

/**
 * InventoryPostingProfile Service
 * CRUD operations for InventoryPostingProfile via the ABP API.
 */
export const inventoryPostingProfileService = new EntityService<InventoryPostingProfile, CreateInventoryPostingProfile, UpdateInventoryPostingProfile>(
  '/api/inventory/inventorypostingprofile',
  'InventoryPostingProfile',
);
